module.exports = __webpack_public_path__ + "media/images/flags/xk-58fd5f55ff6cf850503ff11dd6bd3680.svg";